import { render, staticRenderFns } from "./ProjectFile.vue?vue&type=template&id=ed9934d8&"
import script from "./ProjectFile.vue?vue&type=script&lang=js&"
export * from "./ProjectFile.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports